/**
 * Preferences domain — cache invalidation registry.
 *
 * Both wrapped mutations touch the same `/preferences/` aggregate, so
 * they share `commonPreferenceInvalidations()` which covers the
 * generated read-hook key and the legacy `['preferences']` key still in
 * active use by `api.useGetPreferences` callers.
 */

import type { QueryKey } from '@tanstack/react-query'

import { type InvalidationRule } from '../invalidation/useInvalidatingMutation'
import { getPreferencesQueryKey } from '../generated/hooks/preferencesController'

export type PreferencesMutationId = 'changeMiscSettings' | 'updateReportingUnit'

export function commonPreferenceInvalidations(): QueryKey[] {
  return [getPreferencesQueryKey(), ['preferences']]
}

export const invalidationRegistry: Record<
  PreferencesMutationId,
  InvalidationRule<any>
> = {
  changeMiscSettings: {
    invalidates: () => commonPreferenceInvalidations(),
  },
  updateReportingUnit: {
    invalidates: () => commonPreferenceInvalidations(),
  },
}
